import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-create-word-category',
  templateUrl: './create-word-category.component.html',
  styleUrls: ['./create-word-category.component.scss']
})
export class CreateWordCategoryComponent implements OnInit {
  imageSrc: string;

  @Input() addType: string;

  constructor() { }

  ngOnInit() {
  }

  readURL(event: Event): void {
      if ((event.target as HTMLInputElement).files && (event.target as HTMLInputElement).files[0]) {
          const file = (event.target as HTMLInputElement).files[0];
          const reader = new FileReader();
          reader.onload = e => this.imageSrc = 'url(' + (reader.result  as string) + ')';

          reader.readAsDataURL(file);
      }
  }

}
